module.exports = __webpack_public_path__ + "static/media/visa.cf09d27f.svg";